import { Card } from 'antd';

const BusinessUsers = () => {
  return (
    <Card title="业务用户管理">
      业务用户管理页面
    </Card>
  );
};

export default BusinessUsers; 